import { useQueryClient } from '@tanstack/react-query'
import * as React from 'react'
import { useAnalytics } from '../../../telemetry/AnalyticsProvider'
import { useLogoutMutation } from './logout_gen'

/**
 * A hook that will end the current user session and clear local state.
 */
export const useLogout = (navigateTo = '/') => {
  const analytics = useAnalytics()
  const queryClient = useQueryClient()
  const {
    mutate: logout,
    isLoading,
    isSuccess,
  } = useLogoutMutation({
    onSuccess: () => {
      queryClient.clear()
      analytics.reset() // clear analytics tracking IDs from local storage/cookies
      window.location.assign(navigateTo) // hard refresh to root of application
    },
  })
  React.useEffect(() => {
    if (isSuccess || isLoading) return
    logout({})
  }, [logout, isLoading, isSuccess])
}
